// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/scroll.scss';
import { OverlayScrollbars } from 'overlayscrollbars';
class _HtmlScroll {
    addScroll(node, axis = 'xy', events = null) {
        if (isNullOrUndefined(node))
            return null;
        const overflow = {
            x: axis.includes('x') ? 'scroll' : 'hidden',
            y: axis.includes('y') ? 'scroll' : 'hidden'
        };
        const instance = OverlayScrollbars(node, {
            scrollbars: { theme: 'os-custom-theme', autoHide: 'move', clickScroll: true },
            overflow,
            update: {
                elementEvents: [
                    ['', 'resize'],
                    ['', 'mutation']
                ]
            }
        });
        if (!isNullOrUndefined(events)) {
            if (!isNullOrUndefined(events.scroll)) {
                instance.on('scroll', (event) => {
                    events.scroll();
                });
            }
        }
        return instance;
    }
}
export const HtmlScroll = new _HtmlScroll();
